const CONTROL_COUNTER_ID = 108469576

const getTodayKey = () => new Date().toISOString().slice(0, 10)

const compactPayload = (payload = {}) =>
  Object.entries(payload).reduce((acc, [key, value]) => {
    if (value === null || value === undefined || value === '') return acc
    acc[key] = value
    return acc
  }, {})

const trackGoal = (goal, payload = {}) => {
  if (typeof window === 'undefined') return false

  try {
    const normalizedPayload = compactPayload(payload)
    const hasPayload = Object.keys(normalizedPayload).length > 0

    if (window.ym) {
      if (hasPayload) {
        window.ym(CONTROL_COUNTER_ID, 'reachGoal', goal, normalizedPayload)
      } else {
        window.ym(CONTROL_COUNTER_ID, 'reachGoal', goal)
      }
      return true
    }

    const counter = window[`yaCounter${CONTROL_COUNTER_ID}`]
    if (!counter?.reachGoal) return false

    if (hasPayload) {
      counter.reachGoal(goal, normalizedPayload)
    } else {
      counter.reachGoal(goal)
    }
    return true
  } catch (error) {
    return false
  }
}

// Просмотр страницы при смене маршрута SPA: Метрика сама считает только
// первую загрузку, без `hit` отчёты по страницам и переходам между ними пусты.
export const trackPageHit = (url) => {
  if (typeof window === 'undefined' || !url) return false

  try {
    if (window.ym) {
      window.ym(CONTROL_COUNTER_ID, 'hit', url)
      return true
    }

    const counter = window[`yaCounter${CONTROL_COUNTER_ID}`]
    if (!counter?.hit) return false

    counter.hit(url)
    return true
  } catch (error) {
    return false
  }
}

const oncePerDay = (key) => {
  if (typeof window === 'undefined') return true

  try {
    const today = getTodayKey()
    const storageKey = `metrics:${key}`
    const savedDay = window.localStorage.getItem(storageKey)

    if (savedDay === today) return false

    window.localStorage.setItem(storageKey, today)
    return true
  } catch (error) {
    return true
  }
}

// Пользователь SSO приходит в /users/me с числовым `id` (uuid у него нет),
// поэтому во всех целях идентификатор пользователя — `user_id`.
// homeVariant — последний известный вариант главной (business_apps#1486 §4.4):
// цель уходит сразу после авторизации, до ответа service_partners#me.
export const trackDailyActiveAudience = ({
  userId,
  companyUuid,
  homeVariant,
}) => {
  if (userId && oncePerDay(`active_user:${userId}`)) {
    trackGoal('control_active_user', {
      user_id: userId,
      company_uuid: companyUuid,
      home_variant: homeVariant,
    })
  }

  if (companyUuid && oncePerDay(`active_lk:${companyUuid}`)) {
    trackGoal('control_active_lk', {
      company_uuid: companyUuid,
      user_id: userId,
    })
  }
}

export const trackFirmwareUpdateMetrics = ({
  userId,
  companyUuid,
  intercomUuid,
  firmwareUuid,
  firmwareTag,
  firmwareVersion,
}) => {
  trackGoal('control_firmware_update_used', {
    user_id: userId,
    company_uuid: companyUuid,
    intercom_uuid: intercomUuid,
    firmware_uuid: firmwareUuid,
    firmware_tag: firmwareTag,
    firmware_version: firmwareVersion,
  })

  if (userId && oncePerDay(`firmware_adoption_user:${userId}`)) {
    trackGoal('control_firmware_adoption_user', {
      user_id: userId,
      company_uuid: companyUuid,
    })
  }

  if (companyUuid && oncePerDay(`firmware_adoption_lk:${companyUuid}`)) {
    trackGoal('control_firmware_adoption_lk', {
      company_uuid: companyUuid,
    })
  }
}

export const trackFirmwareUpdateFailed = ({
  userId,
  companyUuid,
  intercomUuid,
  firmwareUuid,
  errorMessage,
}) =>
  trackGoal('control_firmware_update_failed', {
    user_id: userId,
    company_uuid: companyUuid,
    intercom_uuid: intercomUuid,
    firmware_uuid: firmwareUuid,
    error: errorMessage,
  })

export const trackIntercomRebootMetrics = ({
  userId,
  companyUuid,
  intercomUuid,
}) => {
  trackGoal('control_reboot_intercom_used', {
    user_id: userId,
    company_uuid: companyUuid,
    intercom_uuid: intercomUuid,
  })

  if (userId && oncePerDay(`reboot_adoption_user:${userId}`)) {
    trackGoal('control_reboot_intercom_adoption_user', {
      user_id: userId,
      company_uuid: companyUuid,
    })
  }

  if (companyUuid && oncePerDay(`reboot_adoption_lk:${companyUuid}`)) {
    trackGoal('control_reboot_intercom_adoption_lk', {
      company_uuid: companyUuid,
    })
  }
}

export const trackIntercomRebootFailed = ({
  userId,
  companyUuid,
  intercomUuid,
  errorMessage,
}) =>
  trackGoal('control_reboot_intercom_failed', {
    user_id: userId,
    company_uuid: companyUuid,
    intercom_uuid: intercomUuid,
    error: errorMessage,
  })

export default trackGoal
